module.exports = __webpack_public_path__ + "static/media/msp_15.c877f601.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/msp_15.png
// module id = 126
// module chunks = 1 3